import { ReactNode, useMemo } from 'react';

import { Add } from '@mui/icons-material';
import { Box, Divider, IconButton, Typography } from '@mui/material';

import { useAppSelector } from 'state/hooks';

import FontAwesomeIcon from 'features/common/FontAwesomeIcon';
import { StlButton } from 'features/common/StlButton/StlButton';

import { ScenarioSetupUIMode } from '../../../appConstants';
import { selectScenarioSetupUIMode } from '../../../state/workflowSlice';
import { RecentScenarioList } from '../ScenarioList';
import { ScenarioSettings } from '../ScenarioSettings';
import { useScenarioUI } from '../hooks/useScenarioUI';

import styles from './DetourTaskBar.module.css';

const TITLES: Partial<Record<ScenarioSetupUIMode, string>> = {
  [ScenarioSetupUIMode.Create]: 'Create New Scenario',
  [ScenarioSetupUIMode.Edit]: 'Edit Scenario',
  [ScenarioSetupUIMode.Scenarios]: 'Scenario',
};

export function DetourTaskBar() {
  const uiMode = useAppSelector(selectScenarioSetupUIMode);
  const { setCreateMode, setInitialMode } = useScenarioUI();
  const isScenarios = uiMode === ScenarioSetupUIMode.Scenarios;

  const title = useMemo(() => TITLES[uiMode] ?? 'Unknown', [uiMode]);

  let content: ReactNode = null;
  switch (uiMode) {
    case ScenarioSetupUIMode.Create:
    case ScenarioSetupUIMode.Edit:
      content = (
        <Box className={styles.create_wrapper}>
          <ScenarioSettings />
        </Box>
      );
      break;
    default:
      content = <RecentScenarioList />;
      break;
  }

  const handleClose = () => {
    setInitialMode();
    /** alternative flow */
    // if (isScenarios) setInitialMode();
    // else {
    //   // in create/edit mode, info about recenlty open scenario is kept - currentScenarioId!== undefined
    //   if (!currentScenarioId && pastScenario?.scenarios.length > 0)
    //     dispatch(setCurrentScenarioId(pastScenario.scenarios[0].uuid));
    //   setScenariosMode();
    // }
  };
  return (
    <Box className={styles.wrapper}>
      <div className={styles.header}>
        <Typography variant="h3" className={styles.title}>
          {title}
        </Typography>
        <Box className={styles.close_btn_wrapper}>
          {isScenarios && (
            <StlButton
              gray
              isActive
              value="Add new"
              handleClick={setCreateMode}
              icon={<Add />}
              width={88}
            />
          )}
          <IconButton size="small" title="Close" onClick={handleClose}>
            <FontAwesomeIcon name="xmark" type="sharp-solid" size="0.75rem" />
          </IconButton>
        </Box>
      </div>
      <Divider className={styles.divider} />
      {content}
    </Box>
  );
}
